// Components==============
import {
    faArrowLeft,
    faArrowRight,
    faCheck,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React from 'react';
import { heavyPulse } from 'utilities/framerAnimations';
import './Navigate.module.scss';
// =========================

export default function Navigate({
    next,
    previous,
    shouldAnimate,
    canFinish,
}: {
    next?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    previous?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    shouldAnimate: boolean;
    canFinish?: boolean;
}) {
    const variants = {
        still: { scale: 1 },
        animate: heavyPulse,
    };

    return (
        <>
            <div styleName="wrapper">
                <motion.div
                    styleName={`button ${
                        typeof previous !== 'undefined' ? 'blue' : ''
                    }`}
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    onClick={
                        typeof previous !== 'undefined' ? previous : undefined
                    }
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                </motion.div>

                <motion.div
                    styleName={`button ${
                        typeof next !== 'undefined' ? 'blue' : ''
                    } ${canFinish ? 'can-finish' : ''}`}
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    animate={shouldAnimate ? 'animate' : 'still'}
                    variants={variants}
                    onClick={typeof next !== 'undefined' ? next : undefined}
                >
                    {next?.name === 'closeSequence' || canFinish ? (
                        <FontAwesomeIcon icon={faCheck} />
                    ) : (
                        <FontAwesomeIcon icon={faArrowRight} />
                    )}
                </motion.div>
            </div>
        </>
    );
}
